import { createApp } from 'vue';
import LitDiscovery from 'lit-discovery';
import searchComponent from './vue/search.vue';
import * as searchConfig from './search-app-config';

const searchApp = createApp(searchComponent);

searchApp.use(LitDiscovery, {
  fields: searchConfig.fields,  // required. see fields-example.js
  searchOpts: searchConfig.searchOpts,  // required. see config-example.js
  searchComponent: searchComponent  // vue entry point. optional (search-base.vue by default)
})

window.onload = ()=>{
  searchApp.mount('#search-app');
}